import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Dropzone from 'react-dropzone'
import StepResultFields from "./StepResultFields.js"
import Select from "react-select";

class NewSaiCertificationModal extends React.Component {
  state = {
    certificationGroupId: this.props.saiCertificationGroupsTypesSteps[0].id,
    certificationGroup: this.props.saiCertificationGroupsTypesSteps[0],
    certificationStepCode: 0,
    certificationStepResults: [],
    selectedEmployees: [],
    selectedCerificationSteps: [],
    stepResultFields: [],
    employeesSelectOptions: this.props.employees,
    selectedEmployees: []
  };

  componentWillMount() {
    window.addEventListener("openModalToAddSaiCertificate", () => {
      this.openNewModal();
    });
  }

  generateCertificationStepResult(employeeId, stepResultField) {
    return ({
      name: stepResultField.name,
      certification_step_code: stepResultField.code,
      completed_on: stepResultField.completed_on,
      program_director_id: stepResultField.program_director_id,
      instructor_trainer_id: stepResultField.instructor_trainer_id,
      training_center_id: stepResultField.training_center_id,
      certification_type_code: stepResultField.certification_type_code,
      user_id: employeeId
    })
  }

  generateStepResultField(certificationStep) {
    return ({
      name: certificationStep.name,
      code: certificationStep.code,
      certification_type_code: certificationStep.certification_type_code,
      completed_on: null,
      program_director_id: this.props.programDirectors[0].id,
      instructor_trainer_id: this.props.instructorTrainers[0].id,
      training_center_id: this.props.trainingCenters[0].id
    })
  }

  saveCertification() {
    var that = this;

    var formData = new FormData();
    if (Array.isArray(that.state.certificationStepResults)) {
      that.state.certificationStepResults.forEach(stepResult => {
        let nestedFieldId = stepResult.id ? stepResult.id : stepResult._id || new Date().getTime() + Math.floor(Math.random() * 1000);
        Object.keys(stepResult).forEach(stepResultKey => {
          if (stepResultKey == "name") { return };
          formData.append(
            `certification_step_results[][${stepResultKey}]`, stepResult[stepResultKey]
          );
        })
      })
    }

    var config = {
      headers: { 'content-type': 'multipart/form-data' }
    }

    axios.post(
      '/certification_step_results/create_multiple',
      formData,
      config
    ).then(function (response) {
        $('#newSaiCertificationModal').modal('hide');

        that.setState({
          certificationGroupId: that.props.saiCertificationGroupsTypesSteps[0].id,
          certificationGroup: that.props.saiCertificationGroupsTypesSteps[0],
          certificationStepCode: 0,
          selectedCerificationSteps: [],
          selectedEmployees: [],
          certificationStepResults: [],
          stepResultFields: []
        })

        that.props.onAdded(response.data);
      })
      .catch(function (error) {
        toastr.error('Certification not added')
        console.log(error)
      })
  }

  buildStepResults = (selectedEmployees, stepResultFields) => {
    var certificationStepResults = [];
    selectedEmployees.forEach((selectedEmployee) => {
      stepResultFields.forEach(stepResultField => {
        certificationStepResults.push(this.generateCertificationStepResult(selectedEmployee.value, stepResultField));
      });
    });

    return certificationStepResults;
  }

  handleCertificationStepChange = (newCertificationStepCode) => {
    var selectedCerificationSteps = this.state.selectedCerificationSteps;
    var stepResultFields = [];

    var certificationStep = this.state.certificationGroup.certification_steps.find(
      (certificationStep) => newCertificationStepCode == certificationStep.code
    )

    var certificationStepCode = certificationStep.code;

    if (certificationStep.initial_step == true) {
      var certificationInitialSteps = this.state.certificationGroup.certification_steps.filter(
        (certificationStep) => certificationStep.initial_step == 1
      )

      if (certificationInitialSteps.length > 1) {
        certificationInitialSteps.forEach(certificationStep => {
          selectedCerificationSteps.push(certificationStep);
          stepResultFields.push(this.generateStepResultField(certificationStep));
        });
      }
    } else {
      selectedCerificationSteps.push(certificationStep);
      stepResultFields.push(this.generateStepResultField(certificationStep));
    };

    var certificationStepResults = this.buildStepResults(this.state.selectedEmployees, stepResultFields);

    this.setState({
      certificationStepResults: certificationStepResults,
      stepResultFields: stepResultFields,
      selectedCerificationSteps: selectedCerificationSteps,
      certificationStepCode: certificationStepCode
    });
  };

  handleCertificationGroupChange = (newCertificationGroupId) => {
    var certificationGroup = this.props.saiCertificationGroupsTypesSteps.find(
      (saiCertification) => newCertificationGroupId == saiCertification.id
    )
    var certificationGroupId = certificationGroup.id;

    this.setState({
      certificationStepResults: [],
      stepResultFields: [],
      selectedStepResults: [],
      certificationStepCode: 0,
      certificationGroup: certificationGroup,
      certificationGroupId: certificationGroupId
    });
  };

  handleInputChange = (value, key, index=null) => {
    var certificationStepResults = this.state.certificationStepResults;
    var stepResultFields = this.state.stepResultFields;
    var certificationGroup = this.state.certificationGroup;
    var certificationGroupId = this.state.certificationGroupId;
    var selectedEmployees = this.state.selectedEmployees;

    if (key == "selectedEmployees") {
      selectedEmployees = value;
    } else if (key == "stepResultFields") {
      stepResultFields[index] = value;
    }

    certificationStepResults = this.buildStepResults(selectedEmployees, stepResultFields);

    this.setState({
      certificationStepResults: certificationStepResults,
      stepResultFields: stepResultFields,
      certificationGroup: certificationGroup,
      certificationGroupId: certificationGroupId,
      selectedEmployees: selectedEmployees
    });
  };

  openNewModal() {
    var that = this

    $('#newSaiCertificationModal').modal('show')

    $('#newSaiCertificationModal').on('hidden.bs.modal', function (e) {
      that.setState({
        certificationGroupId: that.props.saiCertificationGroupsTypesSteps[0].id,
        certificationGroup: that.props.saiCertificationGroupsTypesSteps[0],
        certificationStepCode: 0,
        selectedCerificationSteps: [],
        selectedEmployees: [],
        certificationStepResults: [],
        stepResultFields: []
      })
    })
  }

  renderSaveButton() {
    var that = this
    var valid = false

    if (this.state.certificationGroupId && this.state.selectedEmployees.length && this.state.certificationStepResults.length) {
      valid = true
    }

    if (valid) {
      return (
        <button type='button'
          className='btn btn-pink full-width'
          onClick={function () { that.saveCertification() }}>
          SAVE
        </button>
      )
    }
    else {
      return (
        <button type='button'
          className='btn btn-pink full-width disabled'>
          SAVE
        </button>
      )
    }
  }

  render() {
    var that = this
    const saiCertificationGroupsTypesSteps = _.sortBy(this.props.saiCertificationGroupsTypesSteps, ['name']);

    var certificationGroup = this.props.saiCertificationGroupsTypesSteps.find(
      (saiCertification) => this.state.certificationGroupId == saiCertification.id
    )

    return (
      <div className='modal fade'
        tabIndex={0}
        id='newSaiCertificationModal'>
        <div className='modal-dialog'>
          <div className='modal-content sai-certificate-modal'>
            <div className='modal-header'>
              <button type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
                tabIndex={0}
                >
                <span aria-hidden='true'>
                  &times;
                </span>
              </button>
              <h1 className='modal-title'>
                New SAI Certification
              </h1>
            </div>
            <div className='modal-body'>
              <div className='row'>
                <div className='col-xs-12 col-md-12'>
                  <label>
                    Certification *
                  </label>
                  <br />
                  <select className='form-control'
                    name='certificationGroupId'
                    title='Certification'
                    value={this.state.certificationGroupId}
                    onChange={e => this.handleCertificationGroupChange(e.target.value)}>
                    {saiCertificationGroupsTypesSteps.map((certificationGroup) =>
                      <option
                        key={certificationGroup.id}
                        value={certificationGroup.id}
                      >
                        {certificationGroup.name}
                      </option>
                    )}
                  </select>

                  <select className='form-control'
                    name='certificationStepCode'
                    title='Step Code'
                    value={this.state.certificationStepCode}
                    onChange={e => this.handleCertificationStepChange(e.target.value)}>
                    <option value=''>
                      Select Step
                    </option>
                    {certificationGroup.certification_steps.map((certificationStep) =>
                      <option
                        key={certificationStep.code}
                        value={certificationStep.code}
                      >
                        {certificationStep.name_with_certification_type}
                      </option>
                    )}
                  </select>
                </div>

                <div className='col-xs-12 col-md-12'>
                  <div className="">
                    <div className="field">
                      <div className="control">
                        <div className="is-fullwidth">
                          <div className="is-medium is-fullwidth">
                          <label htmlFor="select-employees" className='sr-only'>Select Employees</label>
                            <Select
                              closeMenuOnSelect={true}
                              inputId="select-employees"
                              isMulti
                              onChange={e => this.handleInputChange(e, 'selectedEmployees')}
                              options={this.state.employeesSelectOptions.map(opt => ({
                                label: this.props.isSaiAdmin ? opt["full_name_reverse_with_account"] : opt["full_name_reverse"],
                                value: opt["id"]
                              }))}
                              placeholder={"Select Employees *"}
                              removeSelected={true}
                              simpleValue
                              value={this.state.selectedEmployees}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {this.state.stepResultFields && (this.state.stepResultFields.map((stepResultFields, index) =>
                  <StepResultFields
                    key={index}
                    index={index}
                    stepResultFields={stepResultFields}
                    onChange={this.handleInputChange}
                    programDirectors={this.props.programDirectors}
                    instructorTrainers={this.props.instructorTrainers}
                    trainingCenters={this.props.trainingCenters}
                    isSaiAdmin={this.props.isSaiAdmin}
                  />
                ))}
              </div>
            </div>
            <div className='modal-footer'>
              {this.renderSaveButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewSaiCertificationModal.propTypes = {
  saiCertificationGroupsTypesSteps: PropTypes.array,
  programDirectors: PropTypes.array,
  instructorTrainers: PropTypes.array,
  trainingCenters: PropTypes.array,
  employees: PropTypes.array,
  onAdded: PropTypes.func,
  isSaiAdmin: PropTypes.bool
}

export default NewSaiCertificationModal
